import { render } from "./WStatusAlertSound.vue?vue&type=template&id=1fdb4972&ts=true"
import script from "./WStatusAlertSound.vue?vue&type=script&lang=ts"
export * from "./WStatusAlertSound.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__